export const STORAGE_KEYS = {
    ACCESS_TOKEN: "user_token",
    USER_TYPE: "user_profile",
    USER: "user",
} as const

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS]